import { createSlice } from "@reduxjs/toolkit";
import { BuscarLancamentoBancarioModel } from "../../../models/lancamentoBancario/buscarLancamentoBancarioModel";
import { LancamentoBancarioModel } from "../../../models/lancamentoBancario/lancamentoBancarioModel";
import { SaldoContaBanco } from "../../../models/lancamentoBancario/saldoContaBancoModel";
import { buscarLancamentoBancario, buscarDetalheLancamentoFinanceiroContaFinanceira, buscarDetalheLancamentoFinanceiroTransferenciaBancaria } from "../../../services/lancamentoBancarioService";
import { resetAll } from "../../actions/actions";
import { DetalheLancamentoFinanceiroContaFinanceiraModel } from "../../../models/lancamentoBancario/detalheLancamentoFinanceiroContaFinanceiraModel";
import { DetalheLancamentoFinanceiroTransferenciaBancariaModel } from "../../../models/lancamentoBancario/detalheLancamentoFinanceiroTransferenciaBancariaModel";
import dayjs from "dayjs";

dayjs.locale("pt-br");

export interface LancamentoBancarioState {
  //buscar lancamento bancario
  loading: boolean;
  busca: BuscarLancamentoBancarioModel;
  list: LancamentoBancarioModel[];
  entity: LancamentoBancarioModel;
  //buscar detalhes conta financeira
  loadingDetalheConta: boolean;
  detalheContaFinanceira: DetalheLancamentoFinanceiroContaFinanceiraModel;
  //buscar detalhes transferencia
  loadingDetalheTransferencia: boolean;
  detalheTransferencia: DetalheLancamentoFinanceiroTransferenciaBancariaModel;
  //internal
  page: string;
  loadingSaldo: boolean;
  saldoContaBanco: SaldoContaBanco[];
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: LancamentoBancarioState = {
  //buscar lancamento bancario
  loading: false,
  busca: {
    idEmpresa: 0,
    tipoDataFiltro: "SORT",
    dataInicio: dayjs().startOf("month").toDate(),
    dataFim: dayjs().endOf("month").toDate(),
    realizado: true,
    naoRealizado: true,
    vencido: true,
    filtros: null,
  } as BuscarLancamentoBancarioModel,
  list: [],
  entity: {} as LancamentoBancarioModel,
  //buscar detalhes conta financeira
  loadingDetalheConta: false,
  detalheContaFinanceira: {} as DetalheLancamentoFinanceiroContaFinanceiraModel,
  //buscar detalhes transferencia
  loadingDetalheTransferencia: false,
  detalheTransferencia: {} as DetalheLancamentoFinanceiroTransferenciaBancariaModel,
  //internal
  page: "geral",
  loadingSaldo: false,
  saldoContaBanco: [],
  modalCadastrar: false,
  modalDeletar: false,
};

export const lancamentoBancarioSlice = createSlice({
  name: "lancamentoBancario",
  initialState,
  reducers: {
    //buscar lancamento bancario
    setEntityLancamentoBancario: (state, action) => {
      state.entity = action.payload;
    },
    setBuscaLancamentoBancario: (state, action) => {
      state.busca = action.payload;
    },
    //internal
    setPageLancamentoBancario: (state, action) => {
      state.page = action.payload;
    },
    setModalCadastrarLancamentoBancario: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarLancamentoBancario: (state, action) => {
      state.modalDeletar = action.payload;
    },
    resetDetalheTransferencia: (state) => {
      state.detalheTransferencia = {} as DetalheLancamentoFinanceiroTransferenciaBancariaModel;
    },
    resetListLancamentoBancario: (state) => {
      state.list = [];
    },
    resetLancamentoBancario: () => initialState,
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, (state) => {
      state.loading = false;
      state.list = [];
      state.modalCadastrar = false;
      state.entity = {} as LancamentoBancarioModel;
      state.loadingSaldo = false;
      state.saldoContaBanco = [];
      state.modalDeletar = false;
      state.page = "geral";
    });

    //buscar lancamento bancario
    builder.addCase(buscarLancamentoBancario.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarLancamentoBancario.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarLancamentoBancario.rejected, (state, action) => {
      state.loading = false;
    });

    //buscar detalhes conta financeira
    builder.addCase(buscarDetalheLancamentoFinanceiroContaFinanceira.pending, (state) => {
      state.loadingDetalheConta = true;
    });
    builder.addCase(buscarDetalheLancamentoFinanceiroContaFinanceira.fulfilled, (state, action) => {
      state.detalheContaFinanceira = action.payload;
      state.loadingDetalheConta = false;
    });
    builder.addCase(buscarDetalheLancamentoFinanceiroContaFinanceira.rejected, (state, action) => {
      state.loadingDetalheConta = false;
    });

    //buscar detalhes trasnferencia
    builder.addCase(buscarDetalheLancamentoFinanceiroTransferenciaBancaria.pending, (state) => {
      state.loadingDetalheTransferencia = true;
    });
    builder.addCase(buscarDetalheLancamentoFinanceiroTransferenciaBancaria.fulfilled, (state, action) => {
      state.detalheTransferencia = action.payload;
      state.loadingDetalheTransferencia = false;
    });
    builder.addCase(buscarDetalheLancamentoFinanceiroTransferenciaBancaria.rejected, (state, action) => {
      state.loadingDetalheTransferencia = false;
    });
  },
});

export const {
  //buscar lancamento bancario
  setEntityLancamentoBancario,
  setBuscaLancamentoBancario,
  //internal
  setPageLancamentoBancario,
  setModalCadastrarLancamentoBancario,
  setModalDeletarLancamentoBancario,
  resetDetalheTransferencia,
  resetListLancamentoBancario,
  resetLancamentoBancario,
} = lancamentoBancarioSlice.actions;

export default lancamentoBancarioSlice.reducer;
